import React, { Component } from 'react';
import * as util from '../../../utils/EnumMapping';
import MainTable from '../../common/table/MainTable';
import * as columns from './LinkColumns';

class Link extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "LINK";
            item.payable.balanceTypeLabel = util.getLabel(util.balanceRowTypes, item.payable.balanceTypeEnum);
            item.payable.paymentMethodLabel = util.getLabel(util.paymentMethods, item.payable.paymentMethod);
            item.payable.stateLabel = util.getLabel(util.states, item.payable.state);
            return item;
        })
        return data;
    }

    render() {
        return (
            <MainTable
                divClassName="link"
                tableName="Linkek"
                path='/api/links'
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                needAggregate={false}
            />
        );
    }
}

export default Link;
